

























































import { Component, Vue } from "vue-property-decorator";

import { mapGetters } from "vuex";

@Component({
  data() {
    return {
      form: {},
      rules: {
        label: [
          {
            required: true,
            message: "Riempi questo campo per favore",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("machines", ["machineCategoriesList"]),
    ...mapGetters(["inLoading"]),
  },
  created() {
    this.$store.dispatch("machines/getMachineCategories");
  },
  methods: {
    save() {
      (
        this.$refs.form as Vue & {
          validate: (cb: (valid: boolean) => void) => void;
        }
      ).validate((valid: boolean) => {
        if (valid) {
          let action = "machines/createMachineCategory";
          if (this.$data.form.id) {
            action = "machines/editMachineCategory";
          }
          this.$store
            .dispatch(action, {
              ...this.$data.form,
            })
            .then((response) => {
              if (response.status == 201 || response.status == 200) {
                this.$data.form = {};
                this.$store.dispatch("machines/getMachineCategories");
              }
            });
        }
      });
    },
    editMachineCategory(category: any) {
      this.$store.dispatch("machines/editMachineCategory", { ...category });
    },
    confMachineCategory(category: any) {
      this.$data.form = { ...category };
    },
  },
})
export default class SettingsMachinesCategories extends Vue { }
